var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-view-container"},[_c('layout-header')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-f151f0f2","hasScoped":true,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/Breadcrumb.vue
// module id = 1323
// module chunks = 72